(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const validateIfPropertyEquals = require('@clocklimited/validity-validate-if-property-equals')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  return schemata(
    { _id:
      { type: String
      }
    , readOnly:
      { type: Boolean
      , defaultValue: false
      }
    , pencilType:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , date:
      { type: Date
      , validators:
        { all: [ required ]
        }
      }
    , endDate:
      { type: Date
      , validators:
        { all: []
        }
      }
    , artist:
      { type: String
      , validators:
       { all: [ required ]
       }
      }
    , venueName:
      { type: String
      , validators:
        { all: [ validateIfPropertyEquals('venueId', null, required) ]
        }
      }
    , venueId:
      { type: String
      }
    , city:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , country:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , promoterName:
      { type: String
      , validators:
        { all: [ validateIfPropertyEquals('promoterId', null, required) ]
        }
      }
    , promoterId:
      { type: String
      }
    , contacts:
      { type: Array
      , defaultValue: function () { return [] }
      }
    , fee:
      { type: String
      }
    , tax:
      { type: String
      }
    , setTimes:
      { type: String
      }
    , comments:
      { type: String
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/pencil/schema.js","/components/service/pencil")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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